var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.active, 'tab'],on:{"click":function($event){return _vm.$emit('input', _vm.id)}}},[_c('div',{staticClass:"tab-text"},[_vm._v(" "+_vm._s(_vm.label)+" - "),_c('i',{class:{ caution: _vm.caution }},[_vm._v(_vm._s(_vm.subLabel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }